import { TableHead } from "@/components/ui/table";

type SortableTableHeadProps = {
  column: string;
  label: string;
  onSort: (column: string) => void;
  renderSortIcon: (column: string) => React.ReactNode;
};

export const SortableTableHead = ({
  column,
  label,
  onSort,
  renderSortIcon,
}: SortableTableHeadProps) => (
  <TableHead
    className="h-8 cursor-pointer select-none hover:text-foreground/80"
    onClick={() => onSort(column)}
  >
    <div className="flex items-center">
      {label}
      {renderSortIcon(column)}
    </div>
  </TableHead>
);
